'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Input = exports.ClearIcon = exports.SearchIcon = exports.SearchBar = undefined;

var _templateObject = _taggedTemplateLiteral(['\n  position: relative;\n  display: inline-block;\n  line-height: 40px;\n  height: 40px;\n  width: ', 'px;\n  ', '\n  float: ', ';\n'], ['\n  position: relative;\n  display: inline-block;\n  line-height: 40px;\n  height: 40px;\n  width: ', 'px;\n  ', '\n  float: ', ';\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  position: absolute;\n  top: 3px;\n  bottom: 0;\n  left: 0;\n'], ['\n  position: absolute;\n  top: 3px;\n  bottom: 0;\n  left: 0;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  position: absolute;\n  top: 3px;\n  right: 0;\n  bottom: 0;\n  ', '\n  opacity: .6;\n  transition: opacity .3s;\n\n  &:hover {\n    opacity: 1;\n  }\n'], ['\n  position: absolute;\n  top: 3px;\n  right: 0;\n  bottom: 0;\n  ', '\n  opacity: .6;\n  transition: opacity .3s;\n\n  &:hover {\n    opacity: 1;\n  }\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  font-size: ', 'px;\n  font-family: ', ';\n  color: ', ';\n\n  input {\n    padding: 0 20px;\n  }\n'], ['\n  font-size: ', 'px;\n  font-family: ', ';\n  color: ', ';\n\n  input {\n    padding: 0 20px;\n  }\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _helpers = require('../../helpers');

var _nitroTextField = require('../nitro-text-field');

var _nitroTextField2 = _interopRequireDefault(_nitroTextField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var SearchBar = exports.SearchBar = _styledComponents2.default.div(_templateObject, function (props) {
  return props.width;
}, (0, _helpers.boolStyle)('block', 'width: 100%;'), function (props) {
  return props.float;
});

SearchBar.displayName = 'SearchBar';
var SearchIcon = exports.SearchIcon = _styledComponents2.default.div(_templateObject2);

SearchIcon.displayName = 'SearchIcon';
var ClearIcon = exports.ClearIcon = _styledComponents2.default.div(_templateObject3, (0, _helpers.boolStyle)('hide', 'display: none;'));

ClearIcon.displayName = 'ClearIcon';
var Input = exports.Input = (0, _styledComponents2.default)(_nitroTextField2.default)(_templateObject4, function (props) {
  return props.theme.size['3'];
}, function (props) {
  return props.theme.font.default;
}, function (props) {
  return props.theme.color[props.variant];
});
Input.displayName = 'Input';


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-search-bar/styles.js
// module id = 3034
// module chunks = 4